(() => {
  const tagToken = (tag) => `tag:${tag.trim()}`;

  const stripShopTags = (value) => value.replace(/\s*tag:[^\s]+/g, '').trim();

  const prepareSearchForm = (form) => {
    const tag = form.dataset.pseudoShopSearchTag;
    if (!tag) return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    input.value = stripShopTags(input.value);

    form.addEventListener('submit', () => {
      const token = tagToken(tag);
      const cleanValue = stripShopTags(input.value);
      input.value = cleanValue ? `${cleanValue} ${token}` : token;
    });
  };

  document.querySelectorAll('form[data-pseudo-shop-search-tag]').forEach(prepareSearchForm);

  // 2026-05-23 Claude: PSYLOS1 風 fade-up アニメ（IntersectionObserver）
  const initPseudoShopAnim = () => {
    const targets = document.querySelectorAll('.pseudo-shop-anim');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPseudoShopAnim);
  } else {
    initPseudoShopAnim();
  }

  const initCollectionReturnRestore = (root) => {
    if (!root || root.dataset.pcReturnInit === '1') return;
    root.dataset.pcReturnInit = '1';

    const restoreKey = `psylosCollectionReturn:${window.location.pathname}${window.location.search}`;

    try {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (error) {}

    root.addEventListener('click', (event) => {
      const link = event.target.closest && event.target.closest('[data-pc-product-link]');
      if (!link || !root.contains(link)) return;

      const card = link.closest('[data-psylos-card]');
      const payload = {
        y: window.scrollY || window.pageYOffset || 0,
        productId: link.getAttribute('data-product-id') || '',
        ts: Date.now(),
      };

      if (card) {
        const rect = card.getBoundingClientRect();
        payload.cardTop = rect.top + (window.scrollY || window.pageYOffset || 0);
      }

      try {
        sessionStorage.setItem(restoreKey, JSON.stringify(payload));
      } catch (error) {}
    });

    const shouldRestore = (event) => {
      if (event && event.persisted) return true;

      try {
        const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (nav && nav.type === 'back_forward') return true;
      } catch (error) {}

      return document.referrer.includes('/products/');
    };

    const restorePosition = (event) => {
      if (!shouldRestore(event)) return;

      let raw = null;
      try {
        raw = sessionStorage.getItem(restoreKey);
      } catch (error) {}
      if (!raw) return;

      let saved;
      try {
        saved = JSON.parse(raw);
      } catch (error) {
        return;
      }
      if (!saved || Date.now() - saved.ts > 30 * 60 * 1000) return;

      let attempts = 0;
      const target = saved.productId
        ? root.querySelector(`[data-psylos-card][data-product-id="${saved.productId}"]`)
        : null;
      const desiredY = typeof saved.y === 'number' ? saved.y : saved.cardTop || 0;

      const runRestore = () => {
        attempts += 1;
        window.scrollTo(0, Math.max(0, desiredY));

        if (target && attempts === 8) {
          const rect = target.getBoundingClientRect();
          if (rect.top < 80 || rect.top > window.innerHeight * 0.75) {
            target.scrollIntoView({ block: 'center', inline: 'nearest' });
          }
        }

        if (attempts < 8) {
          window.setTimeout(runRestore, attempts < 3 ? 40 : 120);
        }
      };

      requestAnimationFrame(runRestore);
    };

    window.addEventListener('pageshow', restorePosition);
    if (document.readyState === 'complete') {
      restorePosition();
    } else {
      window.addEventListener('load', restorePosition, { once: true });
    }
  };

  const bootCollectionReturnRestore = () => {
    document.querySelectorAll('.psylos-coll').forEach(initCollectionReturnRestore);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCollectionReturnRestore);
  } else {
    bootCollectionReturnRestore();
  }

  document.addEventListener('shopify:section:load', bootCollectionReturnRestore);
})();
